"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizations = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "useOrganizations", { enumerable: true, get: function () { return shared_1.useOrganizations; } });
